var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},[_c('PriceRange',{staticClass:"mr-3 mr-md-4",attrs:{"range":_vm.priceRange}}),_c('FiltersList',{attrs:{"list":_vm.filtersList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }